// Typelizer digest bcf8bd9a63cd901e76043a7744df0b06
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/purchase_orders/:purchase_order_id/status */
  update: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/status', params, options),
    method: 'patch',
  }),
}
